<template>
  <div class="all">
    <el-form label-width="130px"
             :model="dataForm"
             :rules="rules"
             ref="ruleForm">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="客户ID">
            <el-input v-model="dataForm.custId"
                      placeholder="客户ID"
                      maxlength="50"
                      :disabled="true"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号码"
                        prop="mobile">
            <el-input v-model="dataForm.mobile"
                      placeholder="手机号码"
                      maxlength="50"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="客户名称"
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="客户名称"
                      maxlength="50"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="性别"
                        prop="sex">
            <el-select v-model="dataForm.sex"
                       style="width: 100%;"
                       placeholder="性别">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生日"
                        prop="birthday">
            <el-date-picker v-model="dataForm.birthday"
                            type="date"
                            style="width: 100%;"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="职业"
                        prop="occupation">
            <el-input v-model="dataForm.occupation"
                      placeholder="职业"
                      maxlength="50"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱"
                        prop="email">
            <el-input v-model="dataForm.email"
                      placeholder="邮箱"
                      maxlength="50"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="开户银行"
                        prop="ourBank">
            <el-select v-model="dataForm.ourBank"
                       style="width: 100%;"
                       placeholder="开户银行">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号"
                        prop="bankAccount">
            <el-input v-model="dataForm.bankAccount"
                      placeholder="银行账号"
                      maxlength="50"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="注册时间"
                        prop="registTime">
            <el-date-picker v-model="dataForm.registTime"
                            type="date"
                            style="width: 100%;"
                            placeholder="注册时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最近一次时间"
                        prop="lastLogonTime">
            <el-date-picker v-model="dataForm.lastLogonTime"
                            type="date"
                            style="width: 100%;"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="客户来源"
                        prop="registChannel">
            <el-select v-model="dataForm.registChannel"
                       style="width: 100%;"
                       placeholder="客户来源">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="备注"
                        prop="remarks">
            <el-input type="textarea"
                      :rows="2"
                      maxlength="200"
                      placeholder="备注"
                      v-model="dataForm.remarks">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="userfooter">
      <el-button type="primary"
                 size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var validateMoible = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!myreg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      dataForm: {
        value: '1',
        value1: []
      },
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      rules: {
        mobile: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          { required: true, validator: validateMoible, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        occupation: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        ourBank: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        bankAccount: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        registChannel: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (val) {
    }
  },
  components: {
  },
  mounted () {
  }
}
</script>
<style lang="scss">
.userfooter {
  width: 100%;
  height: 40px;
  text-align: center;
}
</style>
